import React, { Component } from 'react';
import {Navbar, Nav, NavItem,Glyphicon,NavDropdown,MenuItem} from 'react-bootstrap';
import {withRouter} from "react-router";

import logo from '../../assets/savaria-logo.png';
import UserStore from '../stores/UserStore';
import Authentication from '../authentication/awsAuthentication';

class SavariaMenu extends Component {

    constructor(props) {
        super(props);

        this._onAuthChange = this._onAuthChange.bind(this);
        this.logout = this.logout.bind(this);
        
        this.state = {
            user : UserStore.user()
        }
    }

    componentDidMount() {
        console.log("[MENU] - componentDidMount");
        UserStore.addChangeListener(this._onAuthChange) ;
    }

    componentWillUnmount() {
        console.log("[MENU] - componentWillUnmount");
        UserStore.removeChangeListener(this._onAuthChange) ;
    }

    _onAuthChange(payload) {
        console.log("[MENU] - authorisation change: ", payload);
        this.setState({user: UserStore.user()});
    }

    logout() {
        Authentication.logout();
        this.props.history.push("/") ;
    }

    render() {
        var u = this.state.user ;

        if (!u) {
            return (
                <Navbar>
                    <Navbar.Header>
                        <Navbar.Brand><img src={logo}  alt="logo" /></Navbar.Brand>
                    </Navbar.Header>
                    <Nav pullRight>
                        <NavItem eventKey={11} onClick={ e => this.props.history.push("/login") } ></NavItem>
                    </Nav>
                </Navbar>
            );
        }
        else {
            var isAdmin = UserStore.isAdministrator() ;
            var isTechSupport = UserStore.isTechSupport() ;

            return (
                <Navbar>
                    <Navbar.Header>
                        <Navbar.Brand><img src={logo}  alt="logo" /></Navbar.Brand>
                    </Navbar.Header>
                    <Nav>
                        {isAdmin && <NavItem eventKey={2} onClick={ e => this.props.history.push("/products") }>Products</NavItem>}
                        {(isAdmin || isTechSupport) && <NavItem eventKey={3} onClick={ e => this.props.history.push("/manage") }>Manage</NavItem>}
                        <NavItem eventKey={4} onClick={ e => this.props.history.push("/jobs") }>Jobs</NavItem>
                    </Nav>
                    <Nav pullRight>
                        <NavItem eventKey={5} onClick={this.logout}><Glyphicon glyph="user" />{' '}Logout</NavItem>              
                    </Nav>
                </Navbar>
            );
        }
       
    }
}

export default withRouter(SavariaMenu);


//<NavItem eventKey={1} onClick={ e => this.props.history.push("/") }><Glyphicon glyph="home" /></NavItem>



// WEBPACK FOOTER //
// ./src/app/components/savariaMenu.js